import cx from "classnames";
import Image from "next/image";
import React, { useState } from "react";

import styles from "./styles.module.css";

type FitProps =
  | {
      objectFit?: "fill" | "cover" | undefined;
      width?: never;
      height?: never;
    }
  | {
      objectFit: "contain" | "none" | "scale-down";
      width: number;
      height: number;
    };

export type MediaProps = FitProps & {
  src?: string;
  imgHover?: string;
  alt: string;
  objectPosition?: string;
  noRoundedEdges?: boolean;
  aspectRatio?: "square" | "portrait" | "landscape" | number;
  priority?: boolean;
  sizes?: string;
  className?: string;
  children?: React.ReactNode;
};

export const Media = ({
  src = "/placeholder.gif",
  imgHover,
  alt,
  objectPosition,
  noRoundedEdges,
  aspectRatio = "square",
  priority = false,
  sizes = "100vw",
  width,
  height,
  objectFit = "fill",
  className,
  children,
}: MediaProps) => {
  const hasAspectRatioClass = typeof aspectRatio === "string";
  const [isHoverImageVisible, setHoverImageVisible] = useState(false);
  return (
    <figure
      className={cx(
        styles.figure,
        { [styles[`_${aspectRatio}`]]: hasAspectRatioClass },
        { [styles["noRoundedEdges"]]: noRoundedEdges },
        className
      )}
      style={
        typeof aspectRatio === "number"
          ? {
              paddingBottom: `${(1 / aspectRatio) * 100}%`,
            }
          : {}
      }
    >
      <Image
        key={src}
        width={width}
        height={height}
        alt={alt}
        src={isHoverImageVisible ? imgHover : src}
        style={{ objectFit }}
        objectPosition={objectPosition}
        className={styles.img}
        priority={priority}
        fill
        sizes={sizes}
        onMouseEnter={() => {
          if (imgHover) {
            setHoverImageVisible(true);
          }
        }}
        onMouseLeave={() => {
          setHoverImageVisible(false);
        }}
      />
      {children}
    </figure>
  );
};
